import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SnackbarMessageInitState } from './state';

export const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState: SnackbarMessageInitState,
    reducers: {
        setSnackbarMessage: {
            reducer: (state, action: PayloadAction<{ text: string; position: 'top' | 'bottom' }>) => {
                state.errorMessage = action.payload.text;
                state.position = action.payload.position;
            },
            prepare: (textOrError: string | any, position: 'top' | 'bottom' = 'bottom') => ({
                payload: {
                    text: textOrError,
                    position,
                },
            }),
        },
        // setSnackbarMessage: (state, action: PayloadAction<string>) => {
        //     state.errorMessage = action.payload;
        // },
    },
});

export const { setSnackbarMessage } = snackbarSlice.actions;
export default snackbarSlice.reducer;
